module.exports = __webpack_public_path__ + "static/media/feature-image-shoe.4b03fc7a.png";